import { createSlice } from '@reduxjs/toolkit'

const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    // Site settings from backend
    siteSettings: {
      siteName: 'Shop Name',
      siteDescription: 'Shop Description',
      currency: 'MDL',
      currencySymbol: 'lei',
      language: 'en',
      theme: 'light',
      logo: '',
      favicon: '',
      contactEmail: '',
      contactPhone: '',
      address: '',
      socialMedia: {},
      seo: {},
      paymentMethods: [],
      shippingMethods: [],
      returnPolicy: '',
      privacyPolicy: '',
      termsOfService: ''
    },
    // User preferences
    userPreferences: {
      theme: 'light',
      language: 'en',
      notifications: true,
      newsletter: false,
      currency: 'MDL'
    },
    loading: false,
    error: null
  },
  reducers: {
    // Load settings from backend
    loadSettings: (state, action) => {
      state.siteSettings = { ...state.siteSettings, ...action.payload }
    },

    // Update site settings
    updateSiteSettings: (state, action) => {
      state.siteSettings = { ...state.siteSettings, ...action.payload }
    },

    // Update user preferences
    updateUserPreferences: (state, action) => {
      state.userPreferences = { ...state.userPreferences, ...action.payload }
    },

    // Set theme
    setTheme: (state, action) => {
      state.userPreferences.theme = action.payload
    },

    // Set language
    setLanguage: (state, action) => {
      state.userPreferences.language = action.payload
    },

    // Set currency
    setCurrency: (state, action) => {
      state.userPreferences.currency = action.payload
    },

    // Set loading state
    setLoading: (state, action) => {
      state.loading = action.payload
    },

    // Set error
    setError: (state, action) => {
      state.error = action.payload
    },

    // Reset to default settings
    resetSettings: (state) => {
      state.userPreferences = {
        theme: 'light',
        language: 'en',
        notifications: true,
        newsletter: false,
        currency: 'MDL'
      }
    }
  }
})

export const {
  loadSettings,
  updateSiteSettings,
  updateUserPreferences,
  setTheme,
  setLanguage,
  setCurrency,
  setLoading,
  setError,
  resetSettings
} = settingsSlice.actions

export default settingsSlice.reducer
